export default "__VITE_ASSET__b4d2a2d4__"